export default "__VITE_ASSET__514010c6__"